/**
 * Build printable route labels for quotation PDF / pricing form from structured addresses.
 */

function pushLine(lines, v) {
  const t = v != null && String(v).trim() !== "" ? String(v).trim() : "";
  if (t) lines.push(t);
}

/**
 * @param {object} q — quotation-like object with origin* fields
 * @returns {string} multiline label or ""
 */
export function formatOriginAddressBlock(q) {
  if (!q) return "";
  const lines = [];
  pushLine(lines, q.originAddress1);
  pushLine(lines, q.originAddress2);
  const cityState = [q.originCity, q.originState].filter((x) => x && String(x).trim()).join(", ");
  pushLine(lines, cityState);
  const pinCountry = [q.originPincode, q.originCountry].filter((x) => x && String(x).trim()).join(" ");
  pushLine(lines, pinCountry);
  return lines.join("\n");
}

/**
 * @param {object} q — quotation-like object with destination* fields
 * @returns {string} multiline label or ""
 */
export function formatDestinationAddressBlock(q) {
  if (!q) return "";
  const lines = [];
  pushLine(lines, q.destinationAddress1);
  pushLine(lines, q.destinationAddress2);
  const cityState = [q.destinationCity, q.destinationState].filter((x) => x && String(x).trim()).join(", ");
  pushLine(lines, cityState);
  const pinCountry = [q.destinationPincode, q.destinationCountry].filter((x) => x && String(x).trim()).join(" ");
  pushLine(lines, pinCountry);
  return lines.join("\n");
}

/**
 * Prefer saved PDF line; else structured address; else city fallback.
 */
export function getQuotationFromLine(q) {
  if (!q) return "—";
  const manual = (q.fromLocation && String(q.fromLocation).trim()) || "";
  if (manual) return manual;
  const block = formatOriginAddressBlock(q);
  if (block) return block;
  const city = (q.originCity && String(q.originCity).trim()) || "";
  return city || "—";
}

export function getQuotationToLine(q) {
  if (!q) return "—";
  const manual = (q.toLocation && String(q.toLocation).trim()) || "";
  if (manual) return manual;
  const block = formatDestinationAddressBlock(q);
  if (block) return block;
  const city = (q.destinationCity && String(q.destinationCity).trim()) || "";
  return city || "—";
}
